// src/components/global/index.js（适配 Vue 2）
import SidebarMenu from '../SidebarMenu.vue'
import FooterComponent from '../FooterComponent.vue'
import gotoTop from '../gotoTop.vue'
import ContactMobile from '../ContactMobile.vue'

// Vue 2 中通过 Vue 构造函数注册全局组件
export function registerGlobalComponents(Vue) {
    Vue.component('SidebarMenu', SidebarMenu)
    Vue.component('FooterComponent', FooterComponent)
    Vue.component('gotoTop', gotoTop)
    Vue.component('ContactMobile', ContactMobile)
}
